/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskMetricResultSummary } from './RiskMetricResultSummary';
import {
  RiskMetricResultSummaryFromJSON,
  RiskMetricResultSummaryFromJSONTyped,
  RiskMetricResultSummaryToJSON,
} from './RiskMetricResultSummary';

/**
 *
 * @export
 * @interface RiskIndicatorMetricResults
 */
export interface RiskIndicatorMetricResults {
  /**
   *
   * @type {number}
   * @memberof RiskIndicatorMetricResults
   */
  readonly id: number;
  /**
   *
   * @type {Array<RiskMetricResultSummary>}
   * @memberof RiskIndicatorMetricResults
   */
  readonly riskMetrics: Array<RiskMetricResultSummary>;
}

/**
 * Check if a given object implements the RiskIndicatorMetricResults interface.
 */
export function instanceOfRiskIndicatorMetricResults(value: object): value is RiskIndicatorMetricResults {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('riskMetrics' in value) || value['riskMetrics'] === undefined) return false;
  return true;
}

export function RiskIndicatorMetricResultsFromJSON(json: any): RiskIndicatorMetricResults {
  return RiskIndicatorMetricResultsFromJSONTyped(json, false);
}

export function RiskIndicatorMetricResultsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RiskIndicatorMetricResults {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    riskMetrics: (json['risk_metrics'] as Array<any>).map(RiskMetricResultSummaryFromJSON),
  };
}

export function RiskIndicatorMetricResultsToJSON(
  value?: Omit<RiskIndicatorMetricResults, 'id' | 'riskMetrics'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
